import { observer } from "mobx-react-lite";
import React from "react";
import {
  Button,
  Checkbox,
  GridRow,
  Header,
  List,
  Modal,
  Segment,
} from "semantic-ui-react";
import { IAssessment } from "../../../Models/Assessment";
import { IAssessmentQuestion } from "../../../Models/AssessmentQuestion";
import style from './Tasklist.module.css'

interface TaskListProps {
  hideTaskList: () => void;
  assessment?: IAssessment;
}

const TaskList: React.FC<TaskListProps> = (props) => {
  const { assessment, hideTaskList } = props;

  return (
    <Modal open={true}>
      <Modal.Content
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <GridRow
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Header as={"h1"}>Task List</Header>
          <Segment basic textAlign="left" id={style['tasks-list']}>
            <List divided relaxed>
              {assessment?.questions
                .slice()
                .sort(
                  (
                    question1: IAssessmentQuestion,
                    question2: IAssessmentQuestion
                  ) => question1.priority - question2.priority
                )
                .map((question: IAssessmentQuestion, i) => {
                  const onChange = () => {
                    question.setAnswer("Yes");
                  };
                  if (!question.isAnswered) {
                    return (
                      <>
                        <List.Item key={`resource-${i}`}>
                          <Checkbox
                            style={{ fontSize: "12pt" }}
                            label={question.question}
                            onChange={onChange}
                            checked={false}
                          />
                          <br />
                          <br />
                        </List.Item>
                      </>
                    );
                  } else {
                    return null;
                  }
                })}
            </List>
            <hr />
            <Header textAlign="center">
              <u>Completed or Not Applicable Tasks</u>
            </Header>
            <List divided relaxed>
              {assessment?.questions.map((question: IAssessmentQuestion, i) => {
                const onChange = () => {
                  question.setAnswer("");
                };
                if (question.isAnswered) {
                  return (
                    <>
                      <List.Item key={`resource-${i}`}>
                        <Checkbox
                          style={{ fontSize: "12pt" }}
                          label={question.question}
                          checked={true}
                          onChange={onChange}
                        />
                        <br />
                        <br />
                      </List.Item>
                    </>
                  );
                } else {
                  return null;
                }
              })}
            </List>
          </Segment>

          <Button onClick={hideTaskList} primary>
            Back
          </Button>
        </GridRow>
      </Modal.Content>
    </Modal>
  );
};

export default observer(TaskList);
